// Turns /api/summary into the small counts shown on sidebar items and dashboard tiles.
export interface BadgeInfo {
  count: number;
  urgent: boolean; // something overdue
}

export function badgesFromSummary(s: any): Record<string, BadgeInfo> {
  if (!s) return {};
  return {
    inquiries: { count: (s.clients?.inquiries ?? 0) + (s.shopify?.newOrders ?? 0), urgent: false },
    production: { count: s.production?.active ?? 0, urgent: (s.production?.overdue ?? 0) > 0 },
    invoices: { count: s.bills?.unpaid ?? 0, urgent: (s.bills?.overdue ?? 0) > 0 },
    proposals: { count: s.clients?.awaiting_proposals ?? 0, urgent: false },
    memo: { count: s.stones?.onMemo ?? 0, urgent: (s.stones?.memoOverdue ?? 0) > 0 },
  };
}
